const initialState = {
    facilityRegisterDetails: null,
    facilityRegisterStatus: false,
    saveRegisteredData:null,
    sendOtpStatus:false,
    confirmOtpStatus:false,
    cloudBaseEmrStatus:false,
    addCloudBaseEmrStatus :false,
    emrOrVpnDetails:null,
    remoteAccessVpnStatus: false,
    remoteAccessVpnDetails:null,
    addRemoteVpnStatus:false,
    addPractitionersStatus :false,
    getPractitionersDetails : null,
    getPractitionersStatus: false,
    editPractitionerSuccess : false,
    deletePractitionerStatus: false,
    sendBaaDocStatus : false,
    saveRegDataStatus:false,
    message: null,
    facilityReqInfoStatus: false,
    facilityReqInfoList: null,
    verifyServiceDetails:null,
    verifyServiceStatus:false,

    facilitySelectTypesDetails: null,
    facilitySelectTypesStatus : false,

    facilitySubmitTypesDetails: null,
    facilitySubmitTypesStatus : false,

    approveStatus: false,

    declineStatus:false,

  };
  export default initialState;